module.exports = __webpack_public_path__ + "img/department.fefa42ef.png";